export class BillableMoovDataDTO {
    public id!: number;
    public customerId!: number;
    public status!: number;
    public moovDefinitionName!: string;
    public moovDefinitionId!: number;
    public moovConfigurationId!: number;
    public sourceMoovFileId!: number;
    public sourceFilename!: string;
    public sourceRecordCount!: number;
    public resultMoovFieldId!: number;
    public resultFilename!: string;
    public resultRecordCount!: number;
    public added!: string;
    public completedAt!: string;
}